import React from 'react'

const CustomDivider = () => {
  return (
    <div style={{
        width: "40%",
        height: "4px",
        backgroundColor:"black",
        margin: "100px 0 40px 12%"
    }}>
    </div>
  )
}

export default CustomDivider